export const STORAGE_KEY = 'RECOMMENDATIONS_PAGE';

/**
 * Currently a thin wrapper around localStorage
 * Abstracts knowledge of the window away and prefills the storage key
 */
export default {
  get() {
    return window.localStorage.getItem(STORAGE_KEY);
  },
  set(value) {
    return window.localStorage.setItem(STORAGE_KEY, value);
  },
  clear() {
    // don't clear all localstorage items
    // Only the one with this key
    window.localStorage.removeItem(STORAGE_KEY);
  }
};
